// Replace instances of the word center with centre. If no instances are found, then do nothing.
// Dual match statement necessary for case aware replacement.
// Do not replace instances of "center" within slugs.

export const localizeCenterToCentre = (text) => {
  return text
    .replace(/center/gi, (match) => match.replace(/enter/gi, 'entre'))
    .replace(/href=(".*?")/gi, (match) => match.replace(/entre/gi, 'enter'))
}
